




























































import Route from 'vue-router';
import { Component, Vue } from 'vue-property-decorator'

import Auth from '@/services/auth'

@Component
export default class Login extends Vue {

  password:string = ""
  keepMeSignIn:boolean = true
  error:string = ""
  
  // lifecycle mounted
  mounted() {
    // For service logout
    Auth.shared.signOut()
  }

  signin() {
    // Invoke authen service
    try {
      this.error = ""
      Auth.shared.signIn(this.password, this.keepMeSignIn)
      // success
      const dest = this.$route.query['redirect'] || '/'
      console.info('Will redirect to', dest)
      this.$router.push({
        path: dest
      } as any)
    } catch(e) {
      // Report Error
      console.error('Failed to sign in:', e)
      this.error = e
    }
  }

  passwordFocus() {
    this.error = ""
  }

  trySignIn(e:KeyboardEvent) {
    if (e.keyCode == 13) {
      this.signin()
    }
  }
}
